var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32922 6.83335C4.89162 6.11785 4.6665 5.23716 4.6665 4.16669C4.6665 2.05613 6.25364 0.166687 8.6665 0.166687C11.0825 0.166687 13.0309 1.78486 13.9998 4.31846C14.9688 1.78486 16.9172 0.166687 19.3332 0.166687C21.746 0.166687 23.3332 2.05613 23.3332 4.16669C23.3332 5.23716 23.1081 6.11785 22.6705 6.83335H24.6665C26.1393 6.83335 27.3332 8.02726 27.3332 9.50002V12.1667C27.3332 13.6394 26.1393 14.8334 24.6665 14.8334V24.1667C24.6665 25.6394 23.4726 26.8334 21.9998 26.8334H5.99984C4.52708 26.8334 3.33317 25.6394 3.33317 24.1667V14.8334C1.86041 14.8334 0.666504 13.6394 0.666504 12.1667V9.50002C0.666504 8.02726 1.86041 6.83335 3.33317 6.83335H5.32922ZM12.6665 9.50002H3.33317V12.1667H12.6665V9.50002ZM24.6665 12.1667H15.3332V9.50002H24.6665V12.1667ZM12.6665 24.1667V14.8334H5.99984V24.1667H12.6665ZM21.9998 24.1667H15.3332V14.8334H21.9998V24.1667ZM8.6665 2.83335C7.83937 2.83335 7.33317 3.43597 7.33317 4.16669C7.33317 5.83766 8.68917 6.63218 11.9057 6.79934C11.5482 4.31549 10.2161 2.83335 8.6665 2.83335ZM15.9998 6.79934C16.3573 4.31549 17.6895 2.83335 19.2391 2.83335C20.0662 2.83335 20.5724 3.43597 20.5724 4.16669C20.5724 5.83766 19.2164 6.63218 15.9998 6.79934Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentIcon);
export default __webpack_public_path__ + "static/media/present-icon.55500e9bda5f3376eadcaf57be45a6c0.svg";
export { ForwardRef as ReactComponent };